import { DESKTOP_GRID_LARGE_SCREEN_CELL } from '../DesktopGrid.constants'

// Item content (icon, text, padding) is sized in CSS for the large-screen
// cell. Below that, scale it down with the cell so it shrinks along with
// the wrapper instead of overflowing it.
export const getItemContentScale = (cellWidth: number) =>
  Math.min(1, cellWidth / DESKTOP_GRID_LARGE_SCREEN_CELL)
